import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { useContext, useEffect } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import SegmentationFiltersEditor from './editor/SegmentationFiltersEditor';
import SegmentationFiltersEditorPortalPanel from './editor/SegmentationFiltersEditorPortalPanel';
import SegmentationFiltersViewer from './viewer/SegmentationFiltersViewer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SegmentationFiltersEmbeddedLayout = () => {
  const {
    filtersContainerRef,
    isInEditMode,
    isEditorClosed,
    props: {
      editorDOMContainer,
      onEditPanelOpenChange,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const showEditor = isInEditMode && !isEditorClosed && !useOnePanel;
  useEffect(() => {
    if (typeof onEditPanelOpenChange === 'function') {
      onEditPanelOpenChange(showEditor);
    }
  }, [onEditPanelOpenChange, showEditor]);
  if (editorDOMContainer) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SegmentationFiltersViewer, {}), showEditor && /*#__PURE__*/_jsx(SegmentationFiltersEditorPortalPanel, {
        children: /*#__PURE__*/_jsx(SegmentationFiltersEditor, {})
      })]
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "stretch",
    display: "inline-flex",
    blockSize: "100%",
    borderColor: "border-core-default",
    borderStyle: "solid",
    borderWidth: "100",
    maxBlockSize: "100vh",
    inlineSize: useOnePanel ? '100%' : 'auto',
    maxInlineSize: useOnePanel ? '1200px' : undefined,
    minInlineSize: useOnePanel ? '400px' : undefined,
    ref: filtersContainerRef,
    children: [/*#__PURE__*/_jsx(Box, {
      basis: useOnePanel ? undefined : 400,
      inlineSize: useOnePanel ? '100%' : '400px',
      children: /*#__PURE__*/_jsx(SegmentationFiltersViewer, {})
    }), showEditor && /*#__PURE__*/_jsx(Box, {
      basis: 400,
      inlineSize: "400px",
      children: /*#__PURE__*/_jsx(View, {
        blockSize: "100%",
        borderInlineStartColor: "border-tertiary-default",
        borderInlineStartStyle: "solid",
        borderInlineStartWidth: "100",
        children: /*#__PURE__*/_jsx(SegmentationFiltersEditor, {})
      })
    })]
  });
};
export default SegmentationFiltersEmbeddedLayout;